import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import picture2 from "./pictures/pic8.png";
import picture3 from "./pictures/TB.png";
import Modal from "react-modal";
import "./home.css";
import Footer from "./Footer";
import HomePage from "./HomePage";
import AppDownloadBanner from "./AppDownloadBanner";
import CipcAutomationFeatures from "./CipcAutomationFeatures";
import { database } from "./firebase";
import { runTransaction } from "firebase/database";

const FILINGSTACK_MANUAL_URL =
  "https://firebasestorage.googleapis.com/v0/b/filing-stack.appspot.com/o/DocumentationImages%2FFilingStack%20Manual.pdf?alt=media&token=686ed631-c987-4de6-80b5-79c2e10aebc0";

const HomePageContent = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [referralCode, setReferralCode] = useState("");

  useEffect(() => {
    // Check for referral code in URL
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get("ref");
    if (refCode) {
      setReferralCode(refCode);
    }
  }, []);

  const handleModal = () => {
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };
  const [loaded, setLoaded] = useState(false);
  const handleLoaded = () => {
    setLoaded(true);
  };

  // Dark mode detection
  const [isDarkMode, setIsDarkMode] = useState(
    typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches,
  );
  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => setIsDarkMode(e.matches);
    if (media.addEventListener) media.addEventListener("change", handler);
    else media.addListener(handler);
    return () => {
      if (media.removeEventListener)
        media.removeEventListener("change", handler);
      else media.removeListener(handler);
    };
  }, []);

  // Function to track referral clicks
  const trackReferralClick = async () => {
    if (!referralCode) return;

    try {
      // Find the referrer's UID and increment their click count
      const referrersSnapshot = await database
        .ref("/OwnerPublic/")
        .orderByChild("referralCode")
        .equalTo(referralCode)
        .once("value");

      if (referrersSnapshot.exists()) {
        const referrers = referrersSnapshot.val();
        const referrerUID = Object.keys(referrers)[0];

        // Increment click count in referrer's analytics
        const referralRef = database.ref(`/Referrals/${referrerUID}`);
        await runTransaction(referralRef, (current) => {
          if (current == null) current = {};
          current.clicks = (current.clicks || 0) + 1;

          // Add event log
          const now = new Date().toISOString().replace(/[.#$\/\[\]]/g, "-");
          if (!current.events) current.events = {};
          current.events[now] = {
            type: "clicks",
            ts: now,
            source: "homepage_cta",
            page: window.location.pathname,
          };
          return current;
        });
      }
    } catch (error) {
      console.log("Referral click tracking error:", error);
      // Don't fail the navigation if tracking fails
    }
  };

  return (
    <div>
      {/* Professional Hero Section */}
      <div
        className="mobile3"
        style={{
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          background:
            "linear-gradient(135deg, #172554 0%, #1e3a8a 25%, #1e40af 50%, #2563eb 75%, #3b82f6 100%)",
          color: "white",
          padding: "clamp(40px, 8vw, 80px) 20px clamp(60px, 10vw, 100px)",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative gradient overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "radial-gradient(circle at 20% 50%, rgba(6, 182, 212, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(14, 116, 144, 0.3) 0%, transparent 50%)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: "1200px",
            margin: "0 auto",
            width: "100%",
          }}
        >
          <HomePage />

          {/* Trust Badge */}
          {/* <div
            style={{
              display: "inline-block",
              backgroundColor: "rgba(59, 130, 246, 0.1)",
              border: "1px solid rgba(59, 130, 246, 0.2)",
              borderRadius: "50px",
              padding: "8px 20px",
              marginBottom: "30px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#1e40af",
            }}
          >
            🏆 Trusted by Accounting Practices Across South Africa
          </div> */}

          <h1
            className="mobile10"
            style={{
              color: "white",
              fontSize: "clamp(2.2rem, 6vw, 4.5rem)",
              fontWeight: "600",
              lineHeight: "1.3",
              marginBottom: "24px",
              fontFamily:
                "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              textShadow: "0 2px 10px rgba(0,0,0,0.1)",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              textAlign: "center",
              margin: "0 auto 24px",
            }}
          >
            Your practice. <br />
            <span
              style={{
                color: "#fef3c7",
                fontWeight: "700",
                display: "inline",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              On Autopilot.
            </span>
          </h1>

        </div>
      </div>

      {/* Stats, CTA, and Product Demo Section */}
      <div
        style={{
          backgroundColor: isDarkMode ? "#111827" : "white",
          padding: "clamp(50px, 10vw, 100px) 20px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <div style={{ marginTop: "clamp(-90px, -7vw, -45px)" }}>
            <AppDownloadBanner />
          </div>

          {/* Key Stats */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "clamp(25px, 5vw, 45px)",
              marginBottom: "clamp(50px, 10vw, 80px)",
              maxWidth: "1000px",
              margin: "0 auto clamp(50px, 10vw, 80px)",
              padding: "0 20px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                padding: "35px 25px",
                borderRadius: "20px",
                background: isDarkMode
                  ? "linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)"
                  : "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
                border: "2px solid rgba(59, 130, 246, 0.2)",
                boxShadow: "0 4px 15px rgba(59, 130, 246, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                position: "relative",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(59, 130, 246, 0.25)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #3b82f6, #1e40af) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(59, 130, 246, 0.1)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  fontSize: "3rem",
                  fontWeight: "800",
                  background:
                    "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  marginBottom: "12px",
                }}
              >
                1M+
              </div>
              <div
                style={{
                  fontSize: "1rem",
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  fontWeight: "600",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                }}
              >
                Seconds Saved
              </div>
            </div>
            <div
              style={{
                textAlign: "center",
                padding: "35px 25px",
                borderRadius: "20px",
                background: isDarkMode
                  ? "linear-gradient(135deg, #065f46 0%, #047857 100%)"
                  : "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
                border: "2px solid rgba(5, 150, 105, 0.2)",
                boxShadow: "0 4px 15px rgba(5, 150, 105, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                position: "relative",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(5, 150, 105, 0.25)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #059669, #047857) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(5, 150, 105, 0.1)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  fontSize: "3rem",
                  fontWeight: "800",
                  background:
                    "linear-gradient(135deg, #059669 0%, #047857 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  marginBottom: "12px",
                }}
              >
                1000s+
              </div>
              <div
                style={{
                  fontSize: "1rem",
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  fontWeight: "600",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                }}
              >
                Transactions Auto-Allocated
              </div>
            </div>
            <div
              style={{
                textAlign: "center",
                padding: "35px 25px",
                borderRadius: "20px",
                background: isDarkMode
                  ? "linear-gradient(135deg, #92400e 0%, #78350f 100%)"
                  : "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                border: "2px solid rgba(245, 158, 11, 0.2)",
                boxShadow: "0 4px 15px rgba(245, 158, 11, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                position: "relative",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(245, 158, 11, 0.25)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #f59e0b, #d97706) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(245, 158, 11, 0.1)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  fontSize: "3rem",
                  fontWeight: "800",
                  background:
                    "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  marginBottom: "12px",
                }}
              >
                Support
              </div>
              <div
                style={{
                  fontSize: "1rem",
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  fontWeight: "600",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                }}
              >
                Live Chat Support
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "0 20px",
              marginBottom: "clamp(50px, 10vw, 80px)",
            }}
          >
            <Link
              to={`/Signup${referralCode ? `?ref=${referralCode}` : ""}`}
              onClick={trackReferralClick}
              style={{
                display: "inline-block",
                background: "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
                color: "white",
                padding: "18px 40px",
                borderRadius: "14px",
                fontSize: "1.15rem",
                fontWeight: "700",
                textDecoration: "none",
                boxShadow: "0 6px 20px rgba(59, 130, 246, 0.4)",
                transition: "all 0.3s ease",
                border: "none",
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 30px rgba(59, 130, 246, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 6px 20px rgba(59, 130, 246, 0.4)";
              }}
            >
              Start Free Trial
            </Link>
            <button
              onClick={handleModal}
              style={{
                display: "inline-block",
                background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                color: "#3b82f6",
                padding: "18px 40px",
                borderRadius: "14px",
                fontSize: "1.15rem",
                fontWeight: "700",
                border: "2px solid #3b82f6",
                cursor: "pointer",
                transition: "all 0.3s ease",
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                boxShadow: "0 4px 15px rgba(59, 130, 246, 0.2)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.background =
                  "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)";
                e.currentTarget.style.color = "white";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(59, 130, 246, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.background =
                  "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                e.currentTarget.style.color = "#3b82f6";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(59, 130, 246, 0.2)";
              }}
            >
              ▶️ Watch Demo
            </button>
          </div>

          {/* Product Screenshot */}
          <div
            style={{
              position: "relative",
              zIndex: 1,
              padding: "0 clamp(20px, 5vw, 80px)",
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(147, 197, 253, 0.12) 100%)",
                borderRadius: "24px",
                padding: "30px",
                border: "2px solid rgba(59, 130, 246, 0.15)",
                display: "inline-block",
                maxWidth: "900px",
                margin: "0 auto",
                boxShadow:
                  "0 10px 40px rgba(59, 130, 246, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.6)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.02)";
                e.currentTarget.style.boxShadow =
                  "0 15px 50px rgba(59, 130, 246, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.8)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow =
                  "0 10px 40px rgba(59, 130, 246, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.6)";
              }}
            >
              <img
                className="imageStyle"
                src={picture2}
                alt="FilingStack Dashboard Preview"
                style={{
                  width: "100%",
                  maxWidth: "800px",
                  height: "auto",
                  borderRadius: "16px",
                  boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>
          </div>

          {/* CircleGrid.org Promotion Banner - FREE Listing for Accounting Practices */}
          <div
            style={{
              marginTop: "40px",
              padding: "30px",
              background:
                "linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.15) 100%)",
              borderRadius: "16px",
              border: "2px solid rgba(16, 185, 129, 0.3)",
              maxWidth: "800px",
              margin: "40px auto 0",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "2rem",
                marginBottom: "15px",
              }}
            >
              🎉 🏢
            </div>
            <h3
              style={{
                color: "#065f46",
                fontSize: "1.5rem",
                fontWeight: "700",
                marginBottom: "15px",
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              }}
            >
              List your practice. For free.
            </h3>
            <p
              style={{
                color: "#047857",
                fontSize: "1.1rem",
                lineHeight: "1.6",
                marginBottom: "20px",
              }}
            >
              <strong>CircleGrid.org</strong> connects South African businesses
              with the right accounting practice. Get discovered by clients
              looking for exactly what you offer.
            </p>
            <a
              href="https://circlegrid.org"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                color: "white",
                padding: "14px 32px",
                borderRadius: "12px",
                fontSize: "1.1rem",
                fontWeight: "700",
                textDecoration: "none",
                boxShadow: "0 4px 15px rgba(16, 185, 129, 0.4)",
                transition: "all 0.3s ease",
                border: "none",
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 6px 20px rgba(16, 185, 129, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(16, 185, 129, 0.4)";
              }}
            >
              🌐 Claim Your FREE Listing →
            </a>
            <p
              style={{
                marginTop: "15px",
                color: "#065f46",
                fontSize: "0.9rem",
                fontStyle: "italic",
              }}
            >
              ✨ Plus: Your accounting practice demo company on FilingStack is
              FREE forever!
            </p>
          </div>
        </div>
      </div>

      {/* Professional Introduction & Value Proposition */}
      <div
        style={{
          background:
            "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 25%, #bae6fd 50%, #7dd3fc 75%, #38bdf8 100%)",
          padding: "clamp(50px, 10vw, 100px) 20px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative pattern overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "radial-gradient(circle at 30% 20%, rgba(59, 130, 246, 0.15) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(6, 182, 212, 0.15) 0%, transparent 50%)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Section Header */}
          <div style={{ marginBottom: "clamp(40px, 8vw, 70px)" }}>
            <h2
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: "700",
                color: "#0c4a6e",
                marginBottom: "20px",
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              }}
            >
              Powerfully Simple.
            </h2>
            <p
              style={{
                fontSize: "1.2rem",
                color: "#0c4a6e",
                maxWidth: "700px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}
            >
              Everything you need. Nothing you don't.
            </p>
          </div>

          {/* Professional Stats Grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "clamp(30px, 6vw, 50px)",
              marginBottom: "clamp(50px, 10vw, 100px)",
            }}
          >
            <div
              style={{
                backgroundColor: "#1e293b",
                border: "2px solid rgba(59, 130, 246, 0.3)",
                borderRadius: "20px",
                padding: "45px 35px",
                textAlign: "center",
                transition: "all 0.3s ease",
                position: "relative",
                boxShadow:
                  "0 4px 20px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 35px rgba(59, 130, 246, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #3b82f6, #06b6d4) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  background: "linear-gradient(135deg, #6366f1, #3b82f6)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 24px",
                  fontSize: "28px",
                  boxShadow: "0 4px 15px rgba(99, 102, 241, 0.4)",
                }}
              >
                🗂️
              </div>
              <h3
                style={{
                  fontSize: "1.8rem",
                  fontWeight: "700",
                  color: "white",
                  marginBottom: "12px",
                }}
              >
                Never Miss a Deadline
              </h3>
              <p
                style={{
                  color: "#e2e8f0",
                  fontSize: "1rem",
                  lineHeight: "1.6",
                }}
              >
                Track VAT, tax and payroll deadlines. Automate CIPC client
                reminders, collect approvals and monitor filing progress.
              </p>
            </div>

            <div
              style={{
                backgroundColor: "#1e293b",
                border: "2px solid rgba(5, 150, 105, 0.3)",
                borderRadius: "20px",
                padding: "45px 35px",
                textAlign: "center",
                transition: "all 0.3s ease",
                position: "relative",
                boxShadow:
                  "0 4px 20px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 35px rgba(5, 150, 105, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #059669, #047857) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  background: "linear-gradient(135deg, #059669, #047857)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 24px",
                  fontSize: "28px",
                  boxShadow: "0 4px 15px rgba(5, 150, 105, 0.4)",
                }}
              >
                ✍️
              </div>
              <h3
                style={{
                  fontSize: "1.8rem",
                  fontWeight: "700",
                  color: "white",
                  marginBottom: "12px",
                }}
              >
                Digital Engagement Letters
              </h3>
              <p
                style={{
                  color: "#e2e8f0",
                  fontSize: "1rem",
                  lineHeight: "1.6",
                }}
              >
                Electronic signatures. Share certificates, registers, and
                resolutions auto-generated in the Compliance Portal.
              </p>
            </div>

            <div
              style={{
                backgroundColor: "#1e293b",
                border: "2px solid rgba(245, 158, 11, 0.3)",
                borderRadius: "20px",
                padding: "45px 35px",
                textAlign: "center",
                transition: "all 0.3s ease",
                position: "relative",
                boxShadow:
                  "0 4px 20px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 35px rgba(245, 158, 11, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #f59e0b, #d97706) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  background: "linear-gradient(135deg, #f59e0b, #d97706)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 24px",
                  fontSize: "28px",
                  boxShadow: "0 4px 15px rgba(245, 158, 11, 0.4)",
                }}
              >
                💼
              </div>
              <h3
                style={{
                  fontSize: "1.8rem",
                  fontWeight: "700",
                  color: "white",
                  marginBottom: "12px",
                }}
              >
                Payroll Perfected
              </h3>
              <p
                style={{
                  color: "#e2e8f0",
                  fontSize: "1rem",
                  lineHeight: "1.6",
                }}
              >
                SARS-compliant. IRP5 automated. EMP201 done.
              </p>
            </div>
          </div>
        </div>

        {/* Video Demo Section */}
        <div
          style={{
            backgroundColor: "#f1f5f9",
            borderRadius: "20px",
            padding: "60px 40px",
            margin: "0 20px",
          }}
        >
          <h3
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              color: "#1e293b",
              marginBottom: "30px",
            }}
          >
            See It In Action
          </h3>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            <svg
              onClick={handleModal}
              style={{
                cursor: "pointer",
                filter: "drop-shadow(0 4px 8px rgba(59, 130, 246, 0.3))",
                transition: "all 0.3s ease",
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              fill="#3b82f6"
              className="bi bi-play-circle-fill"
              viewBox="0 0 16 16"
            >
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
            </svg>
            <div>
              <button
                onClick={handleModal}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                  color: "#1e293b",
                  cursor: "pointer",
                  textAlign: "left",
                }}
              >
                Watch the Demo
              </button>
              <p
                style={{
                  color: "#475569",
                  fontSize: "1rem",
                  margin: "5px 0 0 0",
                  textAlign: "left",
                }}
              >
                Minutes. Everything you need to know.
              </p>
            </div>
          </div>
        </div>

        {/* Professional Resource Links */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "20px",
            maxWidth: "1000px",
            margin: "60px auto 0",
            padding: "0 20px",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #3b82f6, #1e40af)",
              borderRadius: "16px",
              padding: "30px",
              textAlign: "center",
              color: "white",
              transition: "all 0.3s ease",
            }}
          >
            <div
              style={{
                fontSize: "2rem",
                marginBottom: "15px",
              }}
            >
              📚
            </div>
            <h4
              style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                marginBottom: "10px",
                color: "white",
              }}
            >
              Documentation & Training
            </h4>
            <p
              style={{
                marginBottom: "20px",
                opacity: "0.9",
                fontSize: "0.95rem",
              }}
            >
              Comprehensive guides, video tutorials, and best practices for
              accounting professionals.
            </p>
            <a
              href="/UsageInfo"
              target="_blank"
              rel="noreferrer"
              style={{
                color: "#fbbf24",
                fontWeight: "600",
                textDecoration: "none",
                fontSize: "1rem",
              }}
            >
              View Documentation →
            </a>
          </div>

          <div
            style={{
              background: "linear-gradient(135deg, #0f766e, #115e59)",
              borderRadius: "16px",
              padding: "30px",
              textAlign: "center",
              color: "white",
              transition: "all 0.3s ease",
            }}
          >
            <div
              style={{
                fontSize: "2rem",
                marginBottom: "15px",
              }}
            >
              📘
            </div>
            <h4
              style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                marginBottom: "10px",
                color: "white",
              }}
            >
              FilingStack Manual
            </h4>
            <p
              style={{
                marginBottom: "20px",
                opacity: "0.9",
                fontSize: "0.95rem",
              }}
            >
              Download the quickstart PDF manual for offline reference and team
              onboarding.
            </p>
            <a
              href={FILINGSTACK_MANUAL_URL}
              target="_blank"
              rel="noreferrer"
              style={{
                color: "#99f6e4",
                fontWeight: "600",
                textDecoration: "none",
                fontSize: "1rem",
              }}
            >
              Download Quickstart PDF →
            </a>
          </div>

          {/* <div
            style={{
              background: "linear-gradient(135deg, #059669, #047857)",
              borderRadius: "16px",
              padding: "30px",
              textAlign: "center",
              color: "white",
              transition: "all 0.3s ease",
            }}
          >
            <div
              style={{
                fontSize: "2rem",
                marginBottom: "15px",
              }}
            >
              🎓
            </div>
            <h4
              style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                marginBottom: "10px",
                color: "white",
              }}
            >
              Interactive Tutorial
            </h4>
            <p
              style={{
                marginBottom: "20px",
                opacity: "0.9",
                fontSize: "0.95rem",
              }}
            >
              Step-by-step guided tour to get your first client set up in under
              10 minutes.
            </p>
            <Link
              to="/Tutorial"
              target="_blank"
              rel="noreferrer"
              style={{
                color: "#fbbf24",
                fontWeight: "600",
                textDecoration: "none",
                fontSize: "1rem",
              }}
            >
              Start Tutorial →
            </Link>
         
          </div> */}

          <div
            style={{
              background: "linear-gradient(135deg, #dc2626, #b91c1c)",
              borderRadius: "16px",
              padding: "30px",
              textAlign: "center",
              color: "white",
              transition: "all 0.3s ease",
            }}
          >
            <div
              style={{
                fontSize: "2rem",
                marginBottom: "15px",
              }}
            >
              🎥
            </div>
            <h4
              style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                marginBottom: "10px",
                color: "white",
              }}
            >
              Video Library
            </h4>
            <p
              style={{
                marginBottom: "20px",
                opacity: "0.9",
                fontSize: "0.95rem",
              }}
            >
              Watch our quickstart videos and see real accounting software in
              action.
            </p>
            <a
              href="https://youtube.com/@filingstackaccounting4825?feature=shared"
              target="_blank"
              rel="noreferrer"
              style={{
                color: "#fbbf24",
                fontWeight: "600",
                textDecoration: "none",
                fontSize: "1rem",
              }}
            >
              Watch Videos →
            </a>
          </div>
        </div>

        {/* Trust Indicator */}
        <div
          style={{
            backgroundColor: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: "16px",
            padding: "40px",
            textAlign: "center",
            margin: "60px 20px 0",
            maxWidth: "800px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                backgroundColor: "#3b82f6",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
              }}
            >
              🇿🇦
            </div>
            <h3
              style={{
                fontSize: "1.5rem",
                fontWeight: "700",
                color: "#1e293b",
                margin: 0,
              }}
            >
              Local Roots. Global Standards.
            </h3>
          </div>
          <p
            style={{
              color: "#475569",
              fontSize: "1.1rem",
              lineHeight: "1.6",
              margin: 0,
            }}
          >
            Built in SA. For SA. Practicing accountants building for practicing
            accountants. We know the territory.
          </p>
        </div>
      </div>

      <div style={{ padding: "0 20px" }}>
        <CipcAutomationFeatures />
      </div>

      {/* Professional Features Section */}
      <div
        style={{
          backgroundColor: "#f8fafc",
          padding: "100px 20px",
          margin: "0",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "80px",
            }}
          >
            <h2
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: "700",
                color: "#1e293b",
                marginBottom: "20px",
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              }}
            >
              Pro-Grade. Zero Friction.
            </h2>
            <p
              style={{
                fontSize: "1.2rem",
                color: "#1e293b",
                maxWidth: "600px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}
            >
              The tools you need, reimagined.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
              gap: "40px",
            }}
          >
            {/* AI-Powered Processing Feature Card */}
            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(5, 150, 105, 0.25), 0 0 0 2px #059669 inset";
                e.currentTarget.style.borderColor = "#059669";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #059669, #047857)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#d1fae5",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                🤖
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Intelligence Built-in
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Bank statements to books. Instantly. Our AI handles the
                categorization so you don't have to.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#059669",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> Advanced PDF to CSV conversion
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#059669",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Smart transaction categorization
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#059669",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Pattern detection & suggestions
              </div>
            </div>
            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(59, 130, 246, 0.25), 0 0 0 2px #3b82f6 inset";
                e.currentTarget.style.borderColor = "#3b82f6";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #3b82f6, #1e40af)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#dbeafe",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                📄
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Invoicing
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Beautiful, branded invoices. Automated tracking. Get paid
                faster.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#3b82f6",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> Custom branding & templates
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#3b82f6",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Automated payment tracking
              </div>
            </div>

            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(59, 130, 246, 0.25), 0 0 0 2px #3b82f6 inset";
                e.currentTarget.style.borderColor = "#3b82f6";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #3b82f6, #06b6d4)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#dbeafe",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                📄
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                PDF Magic
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#334155",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Drop in a PDF statement. Get clean data. Works with every major
                South African bank.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#3b82f6",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> All SA banks supported
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#3b82f6",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Balance reconciliation
              </div>
            </div>

            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(220, 38, 38, 0.25), 0 0 0 2px #dc2626 inset";
                e.currentTarget.style.borderColor = "#dc2626";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #dc2626, #b91c1c)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#fee2e2",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                📊
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                SARS Ready
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Compliance isn't a feature, it's the standard. Financials, VAT,
                and Tax generated automatically.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#dc2626",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> Automated provisional tax
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#dc2626",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> VAT compliance reporting
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#dc2626",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Draftworx & CaseWare exports
              </div>
            </div>

            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(124, 58, 237, 0.25), 0 0 0 2px #7c3aed inset";
                e.currentTarget.style.borderColor = "#7c3aed";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #7c3aed, #5b21b6)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#ede9fe",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                📈
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Deep Insights
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Real-time dashboards and trial balances. Know your numbers.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#7c3aed",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> Real-time dashboards
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#7c3aed",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Automated trial balances
              </div>
            </div>

            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(8, 145, 178, 0.25), 0 0 0 2px #0891b2 inset";
                e.currentTarget.style.borderColor = "#0891b2";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #0891b2, #0e7490)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#cffafe",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                🔄
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Auto-Pilot
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Teach it once. It remembers. Say goodbye to manual allocation.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#0891b2",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> Custom allocation rules
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#0891b2",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Bulk transaction processing
              </div>
            </div>

            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(234, 88, 12, 0.25), 0 0 0 2px #ea580c inset";
                e.currentTarget.style.borderColor = "#ea580c";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #ea580c, #c2410c)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#fed7aa",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                📋
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Report Beautifully
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Financial statements that impress. P&L, Balance Sheet, and
                Ledgers in a click.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#ea580c",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> Branded financial statements
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#ea580c",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Detailed ledger analysis
              </div>
            </div>

            {/* Working Papers Card */}
            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(16, 185, 129, 0.25), 0 0 0 2px #10b981 inset";
                e.currentTarget.style.borderColor = "#10b981";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #10b981, #059669)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#d1fae5",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                📝
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Working Papers
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Structured audit-ready working papers generated automatically
                from your data.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#10b981",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> Organised by engagement
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#10b981",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Reviewer-ready format
              </div>
            </div>

            {/* Automated Asset Registers Card */}
            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "20px",
                padding: "40px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "2px solid #e2e8f0",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 40px rgba(79, 70, 229, 0.25), 0 0 0 2px #4f46e5 inset";
                e.currentTarget.style.borderColor = "#4f46e5";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #4f46e5, #4338ca)",
                  borderRadius: "20px 20px 0 0",
                }}
              />
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#e0e7ff",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                  fontSize: "24px",
                }}
              >
                🏭
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Automated Asset Registers
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#cbd5e1" : "#1e293b",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                Fixed asset registers maintained automatically. Track additions,
                disposals, and carrying values with ease.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#4f46e5",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                <span>✓</span> Additions & disposals tracked
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#4f46e5",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                <span>✓</span> Automated depreciation schedules
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Professional Trust & Security Section */}
      <div
        style={{
          backgroundColor: isDarkMode ? "#111827" : "white",
          color: isDarkMode ? "#f3f4f6" : "inherit",
          padding: "100px clamp(20px, 5vw, 80px)",
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "80px",
            }}
          >
            <h2
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: "700",
                color: isDarkMode ? "#f3f4f6" : "#1e293b",
                marginBottom: "20px",
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              }}
            >
              Privacy First. Secure Always.
            </h2>
            <p
              style={{
                fontSize: "1.2rem",
                color: isDarkMode ? "#cbd5e1" : "#475569",
                maxWidth: "700px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}
            >
              Bank-grade encryption. POPIA compliant. Your data is yours.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "40px",
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                border: "2px solid rgba(59, 130, 246, 0.2)",
                borderRadius: "24px",
                padding: "50px 40px",
                textAlign: "center",
                transition: "all 0.3s ease",
                position: "relative",
                boxShadow:
                  "0 4px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 35px rgba(59, 130, 246, 0.25), inset 0 1px 0 rgba(255, 255, 255, 1)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #3b82f6, #06b6d4) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  background: "linear-gradient(135deg, #3b82f6, #06b6d4)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 28px",
                  boxShadow: "0 6px 20px rgba(59, 130, 246, 0.4)",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="45"
                  height="45"
                  fill="white"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
                </svg>
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Ironclad Security
              </h3>
              <p
                style={{
                  color: "#1e293b",
                  lineHeight: "1.7",
                  fontSize: "1rem",
                  marginBottom: "20px",
                }}
              >
                SSL/TLS encryption. AES-256 standards. Google Cloud
                infrastructure.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#3b82f6",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Daily Backups
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#3b82f6",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Data Export
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#3b82f6",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Role-based Access
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#3b82f6",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Client Confidentiality
                </div>
              </div>
            </div>

            <div
              style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                border: "2px solid rgba(5, 150, 105, 0.2)",
                borderRadius: "24px",
                padding: "50px 40px",
                textAlign: "center",
                transition: "all 0.3s ease",
                position: "relative",
                boxShadow:
                  "0 4px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 35px rgba(5, 150, 105, 0.25), inset 0 1px 0 rgba(255, 255, 255, 1)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #059669, #047857) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  background: "linear-gradient(135deg, #059669, #047857)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 28px",
                  boxShadow: "0 6px 20px rgba(5, 150, 105, 0.4)",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="45"
                  height="45"
                  fill="white"
                  viewBox="0 0 16 16"
                >
                  <path d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0zm-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z" />
                </svg>
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Lightning Fast
              </h3>
              <p
                style={{
                  color: "#1e293b",
                  lineHeight: "1.7",
                  fontSize: "1rem",
                }}
              >
                Thousands of transactions. Seconds, not minutes. Built for
                scale.
              </p>
            </div>

            <div
              style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                border: "2px solid rgba(124, 58, 237, 0.2)",
                borderRadius: "24px",
                padding: "50px 40px",
                textAlign: "center",
                transition: "all 0.3s ease",
                position: "relative",
                boxShadow:
                  "0 4px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 35px rgba(124, 58, 237, 0.25), inset 0 1px 0 rgba(255, 255, 255, 1)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #7c3aed, #5b21b6) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  background: "linear-gradient(135deg, #7c3aed, #5b21b6)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 28px",
                  boxShadow: "0 6px 20px rgba(124, 58, 237, 0.4)",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="45"
                  height="45"
                  fill="white"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                </svg>
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Expert Support
              </h3>
              <p
                style={{
                  color: "#1e293b",
                  lineHeight: "1.7",
                  fontSize: "1rem",
                  marginBottom: "20px",
                }}
              >
                Direct access to experts. Priority support. Migration assistance
                included.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#7c3aed",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Migration Support
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#7c3aed",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Bulk Uploads
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#7c3aed",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Certification Program
                </div>
              </div>
            </div>

            <div
              style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                border: "2px solid rgba(8, 145, 178, 0.2)",
                borderRadius: "24px",
                padding: "50px 40px",
                textAlign: "center",
                transition: "all 0.3s ease",
                position: "relative",
                boxShadow:
                  "0 4px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 35px rgba(8, 145, 178, 0.25), inset 0 1px 0 rgba(255, 255, 255, 1)";
                e.currentTarget.style.borderImage =
                  "linear-gradient(135deg, #0891b2, #06b6d4) 1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.borderImage = "none";
              }}
            >
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  background: "linear-gradient(135deg, #0891b2, #06b6d4)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 28px",
                  boxShadow: "0 6px 20px rgba(8, 145, 178, 0.4)",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="45"
                  height="45"
                  fill="white"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
                  />
                  <path
                    fillRule="evenodd"
                    d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                  />
                </svg>
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: "#1e293b",
                  marginBottom: "16px",
                }}
              >
                Cloud Native
              </h3>
              <p
                style={{
                  color: "#1e293b",
                  lineHeight: "1.7",
                  fontSize: "1rem",
                  marginBottom: "20px",
                }}
              >
                Accessible anywhere. 99.95% uptime. Complete data portability.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#0891b2",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Automated Backups
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#0891b2",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> Any Device
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#0891b2",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                  }}
                >
                  <span>✓</span> No Lock-in
                </div>
              </div>
            </div>
          </div>

          {/* Workflow Diagram Section */}
          <div
            style={{
              marginTop: "100px",
              marginBottom: "60px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginBottom: "60px",
              }}
            >
              <h2
                style={{
                  fontSize: "clamp(2rem, 4vw, 3rem)",
                  fontWeight: "700",
                  color: "#1e293b",
                  marginBottom: "20px",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                }}
              >
                It just works.
              </h2>
              <p
                style={{
                  fontSize: "1.2rem",
                  color: "#475569",
                  maxWidth: "700px",
                  margin: "0 auto",
                  lineHeight: "1.6",
                }}
              >
                From Chaos to Clarity.
              </p>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "30px",
                maxWidth: "1200px",
                margin: "0 auto",
              }}
            >
              {/* Step 1 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(59, 130, 246, 0.2)";
                  e.currentTarget.style.borderColor = "#3b82f6";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#3b82f6",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(59, 130, 246, 0.4)",
                  }}
                >
                  1
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Onboard
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  Bulk upload clients. Add clerks. Assign tasks. Minutes, not
                  days.
                </p>
              </div>

              {/* Step 2 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(5, 150, 105, 0.2)";
                  e.currentTarget.style.borderColor = "#059669";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#059669",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(5, 150, 105, 0.4)",
                  }}
                >
                  2
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Extract
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  PDF to CSV. Instant. FNB supported natively.
                </p>
              </div>

              {/* Step 3 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(124, 58, 237, 0.2)";
                  e.currentTarget.style.borderColor = "#7c3aed";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#7c3aed",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(124, 58, 237, 0.4)",
                  }}
                >
                  3
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Sync
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  Drag and drop CSVs. Or sync directly with Investec.
                </p>
              </div>

              {/* Step 4 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(220, 38, 38, 0.2)";
                  e.currentTarget.style.borderColor = "#dc2626";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#dc2626",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(220, 38, 38, 0.4)",
                  }}
                >
                  4
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Allocate
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  AI categorization. One click. It learns as you go.
                </p>
              </div>

              {/* Step 5 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(234, 88, 12, 0.2)";
                  e.currentTarget.style.borderColor = "#ea580c";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#ea580c",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(234, 88, 12, 0.4)",
                  }}
                >
                  5
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Report
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  Trial Balance instantly. Financial Statements in a click.
                </p>
              </div>

              {/* Step 6 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(59, 130, 246, 0.2)";
                  e.currentTarget.style.borderColor = "#3b82f6";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#3b82f6",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(59, 130, 246, 0.4)",
                  }}
                >
                  6
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Review
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  Adjustments made simple. Intuitive editing. Full control.
                </p>
              </div>

              {/* Step 7 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(5, 150, 105, 0.2)";
                  e.currentTarget.style.borderColor = "#059669";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#059669",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(5, 150, 105, 0.4)",
                  }}
                >
                  7
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Collaborate
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  Client Portal included. Request docs. Auto-read invoices.
                </p>
              </div>

              {/* Step 8 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(124, 58, 237, 0.2)";
                  e.currentTarget.style.borderColor = "#7c3aed";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#7c3aed",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(124, 58, 237, 0.4)",
                  }}
                >
                  8
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Comply
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  VAT. Payroll. Provisional Tax. Calculated automatically.
                </p>
              </div>

              {/* Step 9 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(220, 38, 38, 0.2)";
                  e.currentTarget.style.borderColor = "#dc2626";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#dc2626",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(220, 38, 38, 0.4)",
                  }}
                >
                  9
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Track
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  Deadlines managed. Team progress tracked. Never miss a beat.
                </p>
              </div>

              {/* Step 10 */}
              <div
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  border: "2px solid #e2e8f0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(234, 88, 12, 0.2)";
                  e.currentTarget.style.borderColor = "#ea580c";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "30px",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#ea580c",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    boxShadow: "0 4px 10px rgba(234, 88, 12, 0.4)",
                  }}
                >
                  10
                </div>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginTop: "20px",
                    marginBottom: "12px",
                  }}
                >
                  Bill
                </h4>
                <p
                  style={{
                    color: "#475569",
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  Professional invoices. Payment tracking. Get paid faster.
                </p>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div
            style={{
              textAlign: "center",
              marginTop: "80px",
              backgroundColor: "#f1f5f9",
              borderRadius: "20px",
              padding: "60px 40px",
            }}
          >
            <h3
              style={{
                fontSize: "2rem",
                fontWeight: "700",
                color: "#1e293b",
                marginBottom: "20px",
              }}
            >
              Ready to Transform Your Practice?
            </h3>
            <p
              style={{
                fontSize: "1.2rem",
                color: "#475569",
                marginBottom: "40px",
                maxWidth: "600px",
                margin: "0 auto 40px",
              }}
            >
              Join hundreds of South African accounting practices already saving
              hours per week.
            </p>
            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Link
                to={`/Signup${referralCode ? `?ref=${referralCode}` : ""}`}
                onClick={trackReferralClick}
                style={{
                  display: "inline-block",
                  backgroundColor: "#3b82f6",
                  color: "white",
                  padding: "18px 36px",
                  borderRadius: "12px",
                  fontSize: "1.2rem",
                  fontWeight: "700",
                  textDecoration: "none",
                  boxShadow: "0 4px 15px rgba(59, 130, 246, 0.4)",
                  transition: "all 0.3s ease",
                }}
              >
                🚀 Start Your Free Trial Now
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Social Proof & Final CTA */}
      <div
        style={{
          backgroundColor: "#f8fafc",
          padding: "80px clamp(20px, 5vw, 80px)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <h3
            style={{
              fontSize: "2rem",
              fontWeight: "700",
              color: isDarkMode ? "#f3f4f6" : "#1e293b",
              marginBottom: "40px",
            }}
          >
            See Our Professional Financial Reports
          </h3>
          <div
            style={{
              backgroundColor: isDarkMode ? "#111827" : "white",
              color: isDarkMode ? "#f3f4f6" : "inherit",
              borderRadius: "24px",
              padding: "clamp(30px, 5vw, 50px)",
              border: "2px solid #e2e8f0",
              marginBottom: "50px",
              maxWidth: "1100px",
              margin: "0 auto 50px",
              boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              className="mobile16"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "16px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
              }}
              alt="Professional Financial Report Example"
              src={picture3}
            />
          </div>
          <p
            style={{
              color: isDarkMode ? "#cbd5e1" : "#1e293b",
              fontSize: "1.1rem",
              marginBottom: "40px",
              maxWidth: "800px",
              margin: "0 auto 40px",
              lineHeight: "1.7",
            }}
          >
            Generate comprehensive financial statements that meet professional
            standards and impress your clients with clean, branded reporting.
          </p>
          <Link
            to={`/Signup${referralCode ? `?ref=${referralCode}` : ""}`}
            onClick={trackReferralClick}
            style={{
              display: "inline-block",
              backgroundColor: "#3b82f6",
              color: "white",
              padding: "18px 36px",
              borderRadius: "12px",
              fontSize: "1.2rem",
              fontWeight: "700",
              textDecoration: "none",
              boxShadow: "0 4px 15px rgba(59, 130, 246, 0.4)",
              transition: "all 0.3s ease",
            }}
          >
            🚀 Start Your Free Trial Now
          </Link>
        </div>
      </div>

      {/* Modal for Video */}
      <Modal
        isOpen={modalOpen}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "1000px",
            height: "80%",
            padding: "20px",
            borderRadius: "20px",
            border: "none",
          },
        }}
      >
        {Modal.setAppElement("#root")}

        <iframe
          onLoad={handleLoaded}
          width="100%"
          height="90%"
          src="https://www.youtube.com/embed/QUWSqB0SP3M?si=ehFNLcdRAxxF0mnO"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          style={{ borderRadius: "10px" }}
        ></iframe>

        {!loaded ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            className="spinner-border text-primary"
            role="status"
          />
        ) : null}
        <button
          style={{
            margin: "20px 0 0 0",
            padding: "12px 24px",
            backgroundColor: "#3b82f6",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: "600",
            cursor: "pointer",
          }}
          onClick={handleModalClose}
        >
          Close Video
        </button>
      </Modal>

      <Footer />
    </div>
  );
};

export default HomePageContent;
